import * as React from 'react'

import { Building2Icon } from 'lucide-react'
import { inject, observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import { ISiteLocation } from '~/client/graph'

import LocationBase from '../../models/LocationObjects/LocationBase'
import LocationAttributesStore from '../../stores/domain/LocationAttributes.store'
import TagsStore from '../../stores/domain/Tags.store'
import { HIERARCHY_SEPARATOR } from '../HierarchyChains'
import SitemapAttributeTag from '../SitemapAttributeTag/SitemapAttributeTag'

import './LocationLabel.scss'

interface IProps {
  locations?: ISiteLocation[]
  isOneColor: boolean
  shouldShowAsTag?: boolean
  shouldAddPadding?: boolean
  shouldNameBeColored?: boolean

  locationAttributesStore?: LocationAttributesStore
  tagsStore?: TagsStore

  locationName?: string
  isShared?: boolean
}

@inject('locationAttributesStore', 'tagsStore')
@observer
export default class WorkflowCardLocationLabel extends React.Component<IProps> {
  public render() {
    const {
      locations,
      tagsStore: { tagStoreByTagTypeMap },
      locationName,
      isShared,
    } = this.props

    if (locationName) {
      return this.renderLocation(null, null, null, locationName)
    }

    if (isShared || !locations.length) {
      return null
    }

    return locations
      .map(location => this.getById(location.id))
      .filter(dto => !!dto)
      .map((dto, index) => {
        const hierarchyChains = dto.getHierarchyChainObjs(tagStoreByTagTypeMap)
        const locationPath = hierarchyChains
          .reverse()
          .map(obj => obj.name)
          .join(HIERARCHY_SEPARATOR)

        return this.renderLocation(dto, index, locationPath)
      })
  }

  private getById = (id: string): LocationBase => {
    return this.props.locationAttributesStore?.getById(id)
  }

  private renderLocation(
    dto?: LocationBase,
    index?: number,
    locationPath?: string,
    locationName?: string,
  ): JSX.Element {
    const {
      isOneColor,
      shouldShowAsTag,
      shouldAddPadding,
      shouldNameBeColored,
    } = this.props
    return (
      <div
        key={(dto?.id || locationName) + index}
        className={classList({
          'workflow-card-location-row row no-flex-children pt4': true,
          'one-color': isOneColor,
          pt4: !!shouldAddPadding && !!index,
        })}
      >
        <SitemapAttributeTag shouldShowAsTag={shouldShowAsTag} dataObject={dto}>
          <div
            className="text large ellipsis parent-tag"
            style={shouldNameBeColored ? { color: dto.color } : {}}
          >
            {locationName && (
              <Building2Icon size={16} className="mr5 tw:align-middle" />
            )}
            {dto?.name || locationName}
          </div>
        </SitemapAttributeTag>
        {locationPath && (
          <span
            className="location-row-chain text ellipsis"
            title={locationPath}
          >
            ({locationPath})
          </span>
        )}
      </div>
    )
  }
}
